import { createContext } from 'react';
import { LoginDialogState } from './LoginDialogState';

export const LoginDialogContext = createContext<LoginDialogState | null>(null);
